import { render } from "./allaccounthis.vue?vue&type=template&id=1a84dfff&scoped=true"
import script from "./allaccounthis.vue?vue&type=script&lang=js"
export * from "./allaccounthis.vue?vue&type=script&lang=js"

import "./allaccounthis.vue?vue&type=style&index=0&id=1a84dfff&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a84dfff"]])

export default __exports__